import script from "./CompanyClaimsPdf.vue?vue&type=script&lang=js"
export * from "./CompanyClaimsPdf.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__